import React from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import { generateDeeplink } from "../../../components/deeplinkDialog/deeplinkDialog.actions";
import { Icon } from "../../../components/icon/Icon";
import { Button } from "../../../components/button/Button";
import { Tooltip } from "../../../components/tooltip/Tooltip";

import "./SpsonBanner.scss";

export const SpsonBanner = ({ isMobileView = false }) => {
  const dispatch = useDispatch();
  const className = classnames("spson-banner", {
    mobile: isMobileView,
  });

  function handleGenerateLinkClick() {
    dispatch(generateDeeplink());
  }

  return (
    <div className={className} data-testid={"spson-banner"}>
      <div className="spson-banner__content">
        <div className="spson-banner__title">
          <Icon icon="fas fa-shield-check icon--spson" />
          <h2 className="text-highlighted">
            <FormattedMessage id="spson_banner_title" />
          </h2>
        </div>
        <div className="spson-banner__description">
          <FormattedMessage id="spson_banner_description" />
        </div>
      </div>
      <div className="spson-banner__actions">
        <Button
          size={"large"}
          className={"spson-banner__button"}
          onClick={handleGenerateLinkClick}
        >
          <FormattedMessage id={"get_started"} />
        </Button>
        <Tooltip content={<FormattedMessage id="spson_banner_help_tooltip" />}>
          <Icon icon={"far fa-question-circle spson-banner__extra-info"} />
        </Tooltip>
      </div>
    </div>
  );
};
